var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          d: "M5 14l-3 2V4.182C2 3.529 2.537 3 3.2 3h12.6c.663 0 1.2.53 1.2 1.182v2.363M6 7h8M6 10h2",
          stroke: "#8EA3EE",
          "stroke-width": "2",
          "stroke-linecap": "round",
        },
      }),
      _c("path", {
        attrs: {
          d: "M10 18H9a1 1 0 01-1-1V8a1 1 0 011-1h12a1 1 0 011 1v12l-3-2h-5M12 11h6M12 14h3",
          stroke: "#2C3143",
          "stroke-width": "2",
          "stroke-linecap": "round",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }